export default "https://yastatic.net/s3/frontend/vconf-frontend/_/room.ad4d48f6.svg";